import { ALARMS_IN_RANGE, RESET_ALARMS_IN_RANGE } from "../actions/types";


const initialState = {data: null};

const alarmRangeReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ALARMS_IN_RANGE:
      return { ...state, data: payload };
    case RESET_ALARMS_IN_RANGE:
        return initialState;
    default:
      return state;
  }
}

export default alarmRangeReducer;